(function () {
  if (window.BelnayCardGallery) return;
  window.BelnayCardGallery = true;

  var sheetQuery = window.matchMedia('(max-width: 749px), (hover: none)');
  var CHECK_ICON = '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true"><path d="M2.2 6.6 5.1 9.6 10.8 3.4" stroke="currentColor" stroke-width="1.4"/></svg>';

  function gallery(card) {
    if (card._belnayGallery) return card._belnayGallery;
    var track = card.querySelector('[data-card-track]');
    var slides = track ? track.querySelectorAll('[data-card-slide], .product-card__slide') : [];
    if (!track || slides.length < 2) return null;
    var state = {
      card: card,
      track: track,
      slides: slides,
      count: slides.length,
      index: 0,
      fill: card.querySelector('[data-card-progress-fill]')
    };
    card._belnayGallery = state;
    return state;
  }

  function wake(state) {
    [state.index - 1, state.index, state.index + 1].forEach(function (n) {
      var slide = state.slides[n];
      if (!slide) return;
      slide.querySelectorAll('img').forEach(function (img) {
        if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
      });
    });
  }

  // Cards far from view, or in a closed panel, keep their extra photos unloaded
  // until they come near the screen or are touched: on a slow phone those
  // photos used to compete with the scripts the page needs to start working.
  var nearObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var card = entry.target;
      if (card.checkVisibility && !card.checkVisibility({ visibilityProperty: true })) return;
      nearObserver.unobserve(card);
      if (card._belnayGallery) wake(card._belnayGallery);
    });
  }, { rootMargin: '200px' }) : null;

  function paint(state, dragPx, animate, quiet) {
    var width = state.track.clientWidth || 1;
    var drag = dragPx || 0;
    if (!animate) state.track.style.transition = 'none';
    else state.track.style.transition = '';
    state.track.style.transform = 'translate3d(calc(' + (-state.index * 100) + '% - ' + drag + 'px), 0, 0)';
    if (state.fill) {
      var pos = state.index + drag / width;
      if (pos < 0) pos = 0;
      if (pos > state.count - 1) pos = state.count - 1;
      state.fill.style.width = (((pos + 1) / state.count) * 100) + '%';
    }
    var prev = state.card.querySelector('[data-card-prev]');
    var next = state.card.querySelector('[data-card-next]');
    if (prev) prev.disabled = state.index <= 0;
    if (next) next.disabled = state.index >= state.count - 1;
    if (!quiet) wake(state);
  }

  function horizontalScroller(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      var style = window.getComputedStyle(node);
      var overflowX = style.overflowX;
      if ((overflowX === 'auto' || overflowX === 'scroll') && node.scrollWidth > node.clientWidth + 8) return node;
      node = node.parentElement;
    }
    return null;
  }

  function releaseProductGhost() {
    var ghost = document.querySelector('.product-enter__ghost');
    if (ghost) ghost.remove();
    document.documentElement.classList.remove('is-product-exit');
  }

  function bindDrag(card) {
    if (card.dataset.dragBound === '1') return;
    var state = gallery(card);
    if (!state) return;
    card.dataset.dragBound = '1';
    var surface = card.querySelector('a') || card;
    var pointer = null;
    var startX = 0;
    var startY = 0;
    var drag = 0;
    var axis = '';
    var suppress = false;
    paint(state, 0, false, !!nearObserver);
    if (nearObserver) {
      nearObserver.observe(card);
      card.addEventListener('pointerenter', function () { wake(state); }, { once: true });
    }

    surface.addEventListener('pointerdown', function (event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.target.closest('button, input, .product-card__sizes')) return;
      if (horizontalScroller(card)) return;
      pointer = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      drag = 0;
      axis = '';
    });

    surface.addEventListener('pointermove', function (event) {
      if (pointer !== event.pointerId) return;
      var dx = startX - event.clientX;
      var dy = startY - event.clientY;
      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') {
          pointer = null;
          return;
        }
        releaseProductGhost();
        if (surface.setPointerCapture) {
          try { surface.setPointerCapture(event.pointerId); } catch (err) {}
        }
      }
      if (axis !== 'x') return;
      event.preventDefault();
      drag = dx;
      paint(state, drag, false);
    }, { passive: false });

    function end(event) {
      if (pointer !== event.pointerId) return;
      if (axis === 'x') {
        var width = state.track.clientWidth || 1;
        if (drag > width * 0.18) state.index = Math.min(state.count - 1, state.index + 1);
        else if (drag < width * -0.18) state.index = Math.max(0, state.index - 1);
        suppress = Math.abs(drag) > 8;
        paint(state, 0, true);
        if (surface.releasePointerCapture) {
          try { surface.releasePointerCapture(event.pointerId); } catch (err) {}
        }
      }
      pointer = null;
      axis = '';
      drag = 0;
    }

    surface.addEventListener('pointerup', end);
    surface.addEventListener('pointercancel', end);
    surface.addEventListener('click', function (event) {
      if (!suppress) return;
      event.preventDefault();
      event.stopPropagation();
      suppress = false;
    }, true);
    window.addEventListener('resize', function () { paint(state, 0, false); });
  }

  function parkSheet(node) {
    if (!node || !node._home) return;
    if (node.parentNode === document.body) node._home.appendChild(node);
  }

  function closeSheets() {
    document.querySelectorAll('[data-card-sizes].is-sheet').forEach(function (sizes) {
      if (sizes._host) resetSizes(sizes._host);
      sizes.classList.remove('is-open');
      var stamp = String(Date.now()) + Math.random();
      sizes._closeStamp = stamp;
      window.setTimeout(function () {
        if (sizes._closeStamp !== stamp || sizes.classList.contains('is-open')) return;
        sizes.classList.remove('is-sheet');
        parkSheet(sizes);
      }, 320);
    });
    document.querySelectorAll('[data-card-sizes-overlay].is-active').forEach(function (overlay) {
      overlay.classList.remove('is-active');
      var stamp = String(Date.now()) + Math.random();
      overlay._closeStamp = stamp;
      window.setTimeout(function () {
        if (overlay._closeStamp !== stamp || overlay.classList.contains('is-active')) return;
        parkSheet(overlay);
      }, 320);
    });
    document.body.classList.remove('card-sizes-open');
    if (window.Belnay && window.Belnay.unlockPageScroll) window.Belnay.unlockPageScroll('card-sizes');
  }

  function openSheet(host) {
    var sizes = host.querySelector('[data-card-sizes]') || host._sizes;
    var overlay = host.querySelector('[data-card-sizes-overlay]') || host._overlay;
    if (!sizes || !overlay) return;
    closeSheets();
    if (!sheetQuery.matches) return;
    sizes._home = sizes._home || sizes.parentNode;
    sizes._host = host;
    overlay._home = overlay._home || overlay.parentNode;
    host._sizes = sizes;
    host._overlay = overlay;
    sizes._closeStamp = '';
    overlay._closeStamp = '';
    document.body.appendChild(overlay);
    document.body.appendChild(sizes);
    overlay.classList.add('is-active');
    sizes.classList.add('is-sheet');
    document.body.classList.add('card-sizes-open');
    if (window.Belnay && window.Belnay.lockPageScroll) window.Belnay.lockPageScroll('card-sizes');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { sizes.classList.add('is-open'); });
    });
    var close = sizes.querySelector('[data-card-sizes-close]');
    if (close) close.focus();
  }

  function markAdded(plus) {
    if (!plus) return;
    if (!plus.getAttribute('data-icon')) plus.setAttribute('data-icon', plus.innerHTML);
    plus.classList.add('is-added');
    plus.innerHTML = CHECK_ICON;
    window.setTimeout(function () {
      plus.classList.remove('is-added');
      var icon = plus.getAttribute('data-icon');
      if (icon) plus.innerHTML = icon;
    }, 1500);
  }

  function resetSizes(host) {
    var inner = host.querySelector('.product-card__sizes-inner');
    if (!inner) return;
    var first = null;
    inner.querySelectorAll('.product-card__size').forEach(function (btn) {
      btn.classList.remove('is-active');
      if (first || btn.tagName !== 'BUTTON' || btn.disabled || btn.classList.contains('is-sold-out')) return;
      first = btn;
    });
    if (first) first.classList.add('is-active');
  }

  function sizeHost(node) {
    if (!node || !node.closest) return null;
    var host = node.closest('[data-size-host]');
    if (host) return host;
    var sheet = node.closest('[data-card-sizes]');
    return (sheet && sheet._host) || null;
  }

  function hostLeft(event) {
    var host = sizeHost(event.target);
    if (!host) return;
    var next = event.relatedTarget;
    if (next && (host.contains(next) || (host._sizes && host._sizes.contains(next)))) return;
    resetSizes(host);
  }

  document.addEventListener('pointerover', function (event) {
    var size = event.target.closest('.product-card__size');
    if (!size || size.disabled || size.classList.contains('is-sold-out')) return;
    var inner = size.closest('.product-card__sizes-inner');
    if (!inner) return;
    inner.querySelectorAll('.product-card__size.is-active').forEach(function (btn) {
      if (btn !== size) btn.classList.remove('is-active');
    });
    size.classList.add('is-active');
  });

  document.addEventListener('pointerout', hostLeft);
  document.addEventListener('focusout', hostLeft);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-card-prev], [data-card-next]');
    if (button) {
      var arrowCard = button.closest('[data-card-gallery]');
      if (!arrowCard) return;
      var arrowState = gallery(arrowCard);
      if (!arrowState) return;
      if (button.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      var step = button.hasAttribute('data-card-prev') ? -1 : 1;
      var nextIndex = arrowState.index + step;
      if (nextIndex < 0 || nextIndex >= arrowState.count) return;
      arrowState.index = nextIndex;
      paint(arrowState, 0, true);
      return;
    }

    var add = event.target.closest('[data-card-add]');
    if (add) {
      event.preventDefault();
      var host = add.closest('[data-size-host]');
      if (host) openSheet(host);
      return;
    }

    if (event.target.closest('.product-card__size--more')) {
      closeSheets();
      return;
    }

    if (event.target.closest('[data-card-sizes-close]') || event.target.closest('[data-card-sizes-overlay]')) {
      event.preventDefault();
      closeSheets();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('product-card__size-form')) return;
    var sizes = form.closest('[data-card-sizes]');
    var host = form.closest('[data-size-host]') || (sizes && sizes._host);
    closeSheets();
    markAdded(host && host.querySelector('[data-card-add]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!document.querySelector('[data-card-sizes].is-sheet')) return;
    event.stopPropagation();
    closeSheets();
  }, true);

  function scan(root) {
    var scope = root || document;
    var cards = [];
    if (scope.matches && scope.matches('[data-card-gallery]')) cards.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-card-gallery]').forEach(function (card) { cards.push(card); });
    }
    cards.forEach(function (card) {
      if (card.querySelector('[data-card-progress]')) bindDrag(card);
      else gallery(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });

  if (window.MutationObserver && document.body) {
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1 || !node.querySelectorAll) return;
          if (node.matches && (node.matches('[data-card-gallery]') || node.querySelector('[data-card-gallery]'))) scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
